export enum PositionFilters {
  Created = 'Created',
  CandidateAdded = 'CandidateAdded',
}
